/**
 * @desc 获取sku物流信息列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.logisticsSupplierSkuFacadeImpl.getLogisticsSkuList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/logisticsSku/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
